<mat-card>
  <mat-card-header>
    <mat-card-title class="popupHeader">
      <div class="mat-card-header-text" i18n>
        Import
      </div>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <input type="file" class="file-input" accept=".json"
    (change)="importFile($event)" #fileUpload>

    <!-- <div id="upload_button">
      <label>
        <input type="file" class="file-input" (change)="importFile($event)" #fileUpload>
        <span class="btn btn-primary">Upload files</span>
      </label>
    </div> -->

  </mat-card-content>
</mat-card>
